import { render, staticRenderFns } from "./TopDialog.vue?vue&type=template&id=0497cddd"
import script from "./TopDialog.vue?vue&type=script&lang=js"
export * from "./TopDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports